export default __webpack_public_path__ + "static/media/Vector3.4858ad84.svg";